module.exports = __webpack_public_path__ + "static/pattern2-06ff37e10b699cd1b7c1d15187e1239f.jpg";